import React from "react";

import DashboardIcon from "@material-ui/icons/Dashboard";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import StorefrontIcon from "@material-ui/icons/Storefront";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

export const menuOptions = [
  { name: "Dashboard", path: "DASHBOARD", icon: <DashboardIcon /> },
  { name: "Chat", path: "CHAT", icon: <ChatBubbleIcon /> },
  {
    name: "Settings",
    icon: <SettingsIcon />,
    subOptions: [
      { name: "Booth", path: "SETTINGS.BOOTH", icon: <StorefrontIcon /> },
      { name: "AttachedFiles", path: "SETTINGS.ATTACHMENTS", icon: <InsertDriveFileIcon /> },
      {
        name: "MyProfile",
        path: "SETTINGS.PROFILE",
        icon: <AccountCircleIcon />,
      },
    ],
  },
];
